const policyHeadingClass = 'text-[18px] md:text-[22px] font-[650] text-[#111827] mb-3';
const policySubHeadingClass = 'text-[15px] md:text-[17px] font-[600] text-[#1f2937] mb-2';
const policyBodyClass = 'text-[13px] md:text-[15px] leading-7 text-[#374151]';
const policyTableThClass =
  'border border-[#D9E0E7] bg-[#F3F7FA] px-3 py-3 text-left text-[12px] md:text-[13px] font-[600] text-[#1f2937]';
const policyTableTdClass =
  'border border-[#D9E0E7] px-3 py-3 align-top text-[12px] md:text-[13px] leading-6 text-[#374151]';

export const PRIVACY_POLICY = [
  <>
    <div className="space-y-6 text-left">
      <div className="rounded-2xl border border-[#D9F2EE] bg-[#F4FBFA] px-4 py-5 md:px-6 md:py-6">
        <p className="text-[20px] md:text-[28px] font-[700] text-[#111827]">(주)브이드림 개인정보 처리방침</p>
        <p className="mt-2 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          주식회사 브이드림(이하 회사)은 정보주체의 자유와 권리 보호를 위해 개인정보 보호법 및 관계 법령이 정한 바를
          준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.
        </p>
        <p className="mt-2 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          회사는 개인정보 보호법 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한
          고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </p>
        <div className="mt-4 rounded-xl bg-white px-4 py-3 text-[12px] md:text-[14px] leading-6 text-[#374151] shadow-sm">
          <p>공고일자: 2026년 4월 27일</p>
          <p>시행일자: 2026년 6월 1일</p>
        </div>
      </div>

      <section>
        <h2 className={policyHeadingClass}>1. 개인정보의 처리 목적, 수집 항목, 보유 및 이용기간</h2>
        <p className={policyBodyClass}>회사는 서비스 제공에 필요한 최소한의 개인정보를 수집·이용합니다.</p>
        <p className={policyBodyClass}>
          정보주체는 필수항목 수집·이용에 동의하지 않을 경우 서비스의 전부 또는 일부 이용이 제한될 수 있으며, 선택항목은
          동의하지 않더라도 해당 항목과 직접 관련된 기능 외 서비스 이용에는 제한이 없습니다. 회사는 민감정보를 처리하는
          경우 별도의 동의를 받거나 법령상 근거가 있는 경우에 한하여 처리합니다. 관계 법령에 따라 일정 기간 보관이
          필요한 경우에는 해당 법령에서 정한 기간 동안 분리 보관할 수 있습니다.
        </p>
        <div className="mt-4 overflow-x-auto rounded-xl border border-[#D9E0E7]">
          <table className="w-full min-w-[1080px] border-collapse">
            <thead>
              <tr>
                <th className={policyTableThClass}>법적 근거</th>
                <th className={policyTableThClass}>구분</th>
                <th className={policyTableThClass}>처리 목적</th>
                <th className={policyTableThClass}>수집 항목</th>
                <th className={policyTableThClass}>보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={policyTableTdClass}>개인정보 보호법 제15조 제1항 제1호(정보주체의 동의)</td>
                <td className={policyTableTdClass}>이력서 작성 전 확인 및 작성 이어하기</td>
                <td className={policyTableTdClass}>본인 확인, 중복 이력서 방지, 작성 이어하기, 후속 연락 관리</td>
                <td className={policyTableTdClass}>이름, 휴대폰번호, 동의 여부, 마지막 작성 단계, 최근 접속 시각</td>
                <td className={policyTableTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>개인정보 보호법 제15조 제1항 제4호</td>
                <td className={policyTableTdClass}>이력서 등록 및 회원 관리</td>
                <td className={policyTableTdClass}>이력서 등록, 조회, 수정, 삭제, 회원 식별, 채용 연계</td>
                <td className={policyTableTdClass}>
                  이름, 생년월일, 성별, 비밀번호, 이메일, 휴대폰번호, 주소, 증명사진, 희망근무조건, 유입경로, 희망직무,
                  학력, 자기소개서
                </td>
                <td className={policyTableTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>
                  개인정보 보호법 제15조 제1항 제1호, 제23조 제1항 제1호, 제23조 제2항
                </td>
                <td className={policyTableTdClass}>민감정보 처리</td>
                <td className={policyTableTdClass}>장애인 맞춤형 직무 매칭, 지원 가능 여부 검토, 제출서류 확인</td>
                <td className={policyTableTdClass}>
                  장애유형, 장애정도, 종합 장애 정도, 장애인증명서 파일, 기초수급 여부, 보훈 여부
                </td>
                <td className={policyTableTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>개인정보 보호법 제15조 제1항 제1호</td>
                <td className={policyTableTdClass}>선택 입력 정보 처리</td>
                <td className={policyTableTdClass}>이력서 보완 및 직무 매칭 정확도 향상</td>
                <td className={policyTableTdClass}>
                  보호자 정보, 경력사항, 자격증, 어학, 수상, 병역 정보 등 이용자가 직접 입력한 항목
                </td>
                <td className={policyTableTdClass}>이력서 삭제 요청 시까지</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>개인정보 보호법 제15조 제1항 제4호, 제6호</td>
                <td className={policyTableTdClass}>간편문의</td>
                <td className={policyTableTdClass}>문의 접수, 민원 처리, 회신, 운영 품질 관리</td>
                <td className={policyTableTdClass}>이름, 연락처, 이메일(선택), 문의유형, 문의내용, 처리기록</td>
                <td className={policyTableTdClass}>문의 처리 완료 후 1년</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>개인정보 보호법 제15조 제1항 제6호</td>
                <td className={policyTableTdClass}>서비스 이용기록 및 보안</td>
                <td className={policyTableTdClass}>접속 통계 분석, 서비스 품질 개선, 비정상 이용 방지, 보안 대응</td>
                <td className={policyTableTdClass}>
                  접속 IP, 쿠키, 브라우저/기기 정보, 접속 로그, 페이지 이동 및 작성 이벤트
                </td>
                <td className={policyTableTdClass}>접속 로그 3개월, 쿠키는 브라우저 설정 또는 만료 시까지</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-[12px] md:text-[13px] leading-6 text-[#4B5563]">
          ※ 회사는 서비스 이용과정에서 접속 로그, IP 주소, 쿠키, 브라우저·기기 정보, 서비스 이용기록 등 정보가 자동으로
          생성·수집될 수 있습니다.
        </p>
        <p className="text-[12px] md:text-[13px] leading-6 text-[#4B5563]">
          ※ 회사는 법령상 보존의무가 있는 경우 해당 법령, 보존 항목 및 보존기간에 따라 개인정보를 분리하여 보관합니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>2. 만 14세 미만 아동의 개인정보 처리</h2>
        <p className={policyBodyClass}>
          회사는 원칙적으로 만 14세 미만 아동의 이력서 등록을 허용하지 않습니다. 회사가 만 14세 미만 아동의 개인정보를
          수집한 사실을 확인한 경우에는 지체 없이 해당 개인정보를 삭제하는 등 필요한 조치를 취합니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>3. 민감정보 처리에 관한 사항</h2>
        <p className={policyBodyClass}>
          회사는 장애유형, 장애정도, 장애인증명서 등 민감정보를 처리할 수 있으며, 이는 장애인 맞춤형 직무 매칭, 지원
          가능 여부 검토, 제출서류 확인 등 서비스 제공에 필요한 범위에서만 처리합니다. 회사는 민감정보를 처리하는 경우
          정보주체의 별도 동의를 받거나 관계 법령에서 허용하는 경우에 한하여 처리하며, 처리 목적 달성에 필요한 최소한의
          범위로 제한합니다. 또한 민감정보에 대해서는 별도 접근권한 부여, 접근기록 관리, 저장 시 보호조치 등 강화된
          안전성 확보조치를 적용합니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>4. 개인정보의 제3자 제공</h2>
        <p className={policyBodyClass}>
          회사는 정보주체의 개인정보를 정보 주체의 선택에 따른 채용 연계 제공을 제외하고는 원칙적으로 제3자에게 제공하지
          않습니다.
        </p>
        <ol className="list-decimal space-y-1 pl-5 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <li>정보주체가 사전에 동의한 경우</li>
          <li>법령에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</li>
          <li>정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
          <li>기타 관계 법령에서 허용하는 경우</li>
        </ol>
        <p className={`${policyBodyClass} mt-3`}>
          회사가 개인정보를 제3자에게 제공하는 경우에는 제공받는 자, 제공 목적, 제공 항목, 보유 및 이용기간, 동의 거부권
          및 불이익 여부 등을 정보주체에게 알리고 필요한 경우 별도 동의를 받습니다.
        </p>
        <div className="mt-4 overflow-x-auto rounded-xl border border-[#D9E0E7]">
          <table className="w-full min-w-[760px] border-collapse">
            <thead>
              <tr>
                <th className={policyTableThClass}>제공받는 자</th>
                <th className={policyTableThClass}>제공 목적</th>
                <th className={policyTableThClass}>제공 항목</th>
                <th className={policyTableThClass}>보유 및 이용기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={policyTableTdClass}>채용을 진행하는 구인기업</td>
                <td className={policyTableTdClass}>채용 절차 진행, 면접 및 입사 검토</td>
                <td className={policyTableTdClass}>
                  이름, 연락처, 이력서 기재사항, 자기소개서, 장애 관련 지원 필요사항 중 채용 진행에 필요한 범위
                </td>
                <td className={policyTableTdClass}>채용 절차 종료 시까지 또는 관련 법령에 따른 기간</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className={policyHeadingClass}>5. 개인정보 처리업무의 위탁</h2>
        <p className={policyBodyClass}>
          회사는 원활한 서비스 제공을 위하여 필요한 범위 내에서 개인정보 처리업무를 위탁할 수 있습니다.
        </p>
        <p className={policyBodyClass}>
          회사는 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행 목적 외 개인정보 처리금지, 기술적·관리적
          보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등에 명시하고 수탁자가
          개인정보를 안전하게 처리하는지를 감독합니다. 위탁업무의 내용이나 수탁자가 변경되는 경우에는 본 개인정보
          처리방침을 통하여 지체 없이 공개하겠습니다.
        </p>
        <div className="mt-4 overflow-x-auto rounded-xl border border-[#D9E0E7]">
          <table className="w-full min-w-[760px] border-collapse">
            <thead>
              <tr>
                <th className={policyTableThClass}>수탁자</th>
                <th className={policyTableThClass}>위탁업무</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={policyTableTdClass}>(주)SU소프트</td>
                <td className={policyTableTdClass}>국내 IDC 서버 운영 및 시스템 유지관리</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>Google Cloud Platform (Firebase Storage)</td>
                <td className={policyTableTdClass}>증명사진, 장애인증명서 등 첨부파일 저장</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>(주)채널코퍼레이션</td>
                <td className={policyTableTdClass}>고객 상담 응대 및 영업</td>
              </tr>
              <tr>
                <td className={policyTableTdClass}>(주)솔라피</td>
                <td className={policyTableTdClass}>알림톡 및 문자메시지 발송</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className={policyHeadingClass}>6. 개인정보의 국외 이전에 관한 사항</h2>
        <p className={policyBodyClass}>
          회사는 서비스 이용 형태 분석 및 서비스 개선을 위하여 다음과 같이 개인정보를 국외로 이전할 수 있습니다.
        </p>
        <div className="mt-4 rounded-xl border border-[#D9E0E7] bg-[#FAFAFA] p-4 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <p>
            <strong>이전받는 자:</strong> Google LLC
          </p>
          <p>
            <strong>연락처:</strong> Google Analytics 서비스 관련 문의처 또는 Google 개인정보 보호 관련 안내 페이지
          </p>
          <p>
            <strong>이전되는 국가:</strong> 미국
          </p>
          <p>
            <strong>이전 일시 및 방법:</strong> 이용자가 웹사이트를 이용하는 시점에 네트워크를 통하여 전송
          </p>
          <p>
            <strong>이전 항목:</strong> 쿠키, 기기·브라우저 관련 정보, IP 주소, 페이지 조회, 클릭, 작성 단계 이벤트 등
            이용행태 정보
          </p>
          <p>
            <strong>이전 목적:</strong> 웹사이트 이용 통계 분석, 이력서 작성 흐름 분석, 이용자 이탈 구간 파악, UI/UX
            개선, 서비스 품질 향상
          </p>
          <p>
            <strong>보유 및 이용기간:</strong> Google Analytics 설정 및 정책에 따른 기간까지
          </p>
        </div>
        <p className={`${policyBodyClass} mt-3`}>
          회사는 Google Analytics를 광고 목적이 아닌 서비스 운영 및 개선 목적 범위에서만 이용합니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>7. 개인정보의 파기 절차 및 방법</h2>
        <p className={policyBodyClass}>
          회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당
          개인정보를 파기합니다. 다만, 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보를 다른
          개인정보와 분리하여 보관한 후 법정 보존기간이 경과하면 파기합니다. 회사는 법령상 보존의무가 있는 경우 보존
          근거, 보존 항목 및 보존기간을 본 처리방침 또는 별도 안내를 통해 공개합니다.
        </p>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          <div className="rounded-xl border border-[#E5E7EB] bg-[#FAFAFA] p-4">
            <h3 className={policySubHeadingClass}>파기 절차</h3>
            <ul className="list-disc space-y-1 pl-5 text-[13px] md:text-[14px] leading-6 text-[#374151]">
              <li>파기 사유가 발생한 개인정보를 선정합니다.</li>
              <li>내부 기준에 따라 파기 여부를 검토합니다.</li>
              <li>보존 필요성이 없는 개인정보는 지체 없이 파기합니다.</li>
            </ul>
          </div>
          <div className="rounded-xl border border-[#E5E7EB] bg-[#FAFAFA] p-4">
            <h3 className={policySubHeadingClass}>파기 방법</h3>
            <ul className="list-disc space-y-1 pl-5 text-[13px] md:text-[14px] leading-6 text-[#374151]">
              <li>전자적 파일 형태의 개인정보는 복구 또는 재생이 어렵도록 삭제 또는 초기화합니다.</li>
              <li>종이 문서 형태의 개인정보는 분쇄 또는 소각합니다.</li>
            </ul>
          </div>
        </div>
      </section>

      <section>
        <h2 className={policyHeadingClass}>8. 정보주체와 법정대리인의 권리·의무 및 행사방법</h2>
        <p className={policyBodyClass}>
          정보주체는 회사에 대해 언제든지 개인정보 열람, 정정·삭제, 처리정지, 동의 철회 등을 요구할 수 있습니다. 권리
          행사는 서면, 전자우편, 고객센터, 서비스 내 기능 등 회사가 제공하는 방법을 통하여 할 수 있으며, 회사는 관련
          법령이 정한 기간 내에 지체 없이 조치하겠습니다.
        </p>
        <p className={policyBodyClass}>
          정보주체의 법정대리인이나 위임을 받은 대리인은 관계 법령에서 정한 위임장 등 필요한 서류를 제출하여 권리를
          행사할 수 있습니다. 회사는 권리 행사 요청자의 본인 여부 또는 정당한 대리권을 확인할 수 있습니다.
        </p>
        <p className={policyBodyClass}>
          다만, 법령에서 해당 개인정보가 수집 대상으로 명시되어 있거나 보존의무가 있는 경우, 다른 사람의 생명·신체 또는
          재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우 등 관계 법령에서 정한 사유가 있으면 권리 행사가 제한될
          수 있습니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>9. 개인정보의 안전성 확보조치</h2>
        <ol className="list-decimal space-y-2 pl-5 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <li>관리적 조치: 내부관리계획 수립·시행, 개인정보 취급자 지정 및 최소화, 정기적 교육 및 점검</li>
          <li>
            기술적 조치: 개인정보처리시스템 등에 대한 접근권한 관리, 접근통제시스템 운영, 고유식별정보·비밀번호 등
            중요정보의 암호화, 보안프로그램 설치 및 갱신, 접속기록의 보관 및 점검
          </li>
          <li>물리적 조치: 전산실, 자료보관실 등 개인정보 보관장소에 대한 접근통제</li>
        </ol>
        <p className={`${policyBodyClass} mt-3`}>
          회사는 개인정보의 안전성 확보에 필요한 세부 보호조치를 지속적으로 점검하고 개선합니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>10. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h2>
        <p className={policyBodyClass}>
          회사는 서비스 이용 편의 제공, 이용형태 분석, 보안 대응, 작성 상태 유지 등을 위하여 쿠키(cookie),
          세션정보(session), 로컬 또는 세션 스토리지 등 자동 수집 장치를 사용할 수 있습니다.
        </p>
        <p className={policyBodyClass}>
          회사는 서비스 이용 형태를 분석하여 이력서 작성 흐름을 개선하고 이용자 이탈 구간을 파악하기 위해 Google
          Analytics를 이용할 수 있습니다.
        </p>
        <div className="mt-4 rounded-xl border border-[#D9E0E7] bg-[#FAFAFA] p-4 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <p>
            <strong>자동 수집 장치 명칭:</strong> Google Analytics
          </p>
          <p>
            <strong>자동 수집 장치 종류:</strong> 자바스크립트 기반 분석 도구
          </p>
          <p>
            <strong>수집 주체:</strong> Google LLC
          </p>
          <p>
            <strong>수집 항목:</strong> 쿠키, 기기·브라우저 관련 정보, IP 주소, 페이지 조회, 버튼 클릭, 작성 단계 이벤트
            등 이용행태 정보
          </p>
          <p>
            <strong>수집 목적:</strong> 웹사이트 이용 통계 분석, 이력서 작성 흐름 분석, 이용자 이탈 구간 파악, UI/UX
            개선, 서비스 품질 향상
          </p>
          <p>
            <strong>보유기간:</strong> Google Analytics 설정에 따른 기간
          </p>
          <p>
            <strong>거부 방법:</strong> 이용자는 웹브라우저의 쿠키 설정을 변경하거나 Google Analytics Opt-out Browser
            Add-on을 이용하여 이용행태 정보 수집을 거부할 수 있습니다.
          </p>
        </div>
        <p className={`${policyBodyClass} mt-3`}>
          회사는 Google Analytics를 광고 목적이 아닌 서비스 운영 및 개선 목적 범위에서만 이용합니다. 이용자가 쿠키 저장
          또는 Google Analytics 수집을 거부하더라도 기본적인 서비스 이용은 가능하나, 로그인 유지, 작성 이어하기, 맞춤형
          설정 유지 또는 일부 분석 기반 서비스 개선에 반영되는 정보 수집은 제한될 수 있습니다.
        </p>
        <ul className="list-disc space-y-1 pl-5 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <li>Chrome: 설정 &gt; 개인정보 보호 및 보안 &gt; 쿠키 및 기타 사이트 데이터</li>
          <li>Edge: 설정 &gt; 쿠키 및 사이트 권한</li>
          <li>Safari: 설정 &gt; 고급 &gt; 모든 쿠키 차단</li>
        </ul>
        <p className={`${policyBodyClass} mt-3`}>
          회사가 사용하는 쿠키 등의 구체적인 항목, 목적, 보유기간은 서비스 운영정책 또는 별도 안내 화면을 통해 추가로
          고지할 수 있습니다.
        </p>
      </section>

      <section>
        <h2 className={policyHeadingClass}>11. 개인정보 보호책임자 및 개인정보 열람청구 담당부서</h2>
        <p className={policyBodyClass}>
          회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제를
          위하여 아래와 같이 개인정보 보호책임자 및 담당부서를 지정하고 있습니다. 정보주체는 회사의 서비스를 이용하면서
          발생한 모든 개인정보 보호 관련 문의, 열람청구, 정정·삭제, 처리정지, 동의 철회, 고충처리 등을 아래의 연락처로
          문의할 수 있습니다. 회사는 문의를 받은 후 지체 없이 답변 및 처리하겠습니다.
        </p>
        <div className="mt-4 grid gap-4 md:grid-cols-2">
          <div className="rounded-xl border border-[#F2D89A] bg-[#FFF9E8] p-4">
            <h3 className={policySubHeadingClass}>개인정보 보호책임자</h3>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">성명: 유진섭</p>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">소속: 기업부설연구소</p>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">직위: 소장</p>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">이메일: security@vdream.co.kr</p>
          </div>
          <div className="rounded-xl border border-[#D9E0E7] bg-[#FAFAFA] p-4">
            <h3 className={policySubHeadingClass}>개인정보 열람청구 및 고객상담 담당부서</h3>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">부서명: 장애인인재경영팀</p>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">전화번호: 1644-8619</p>
            <p className="text-[13px] md:text-[14px] leading-6 text-[#374151]">이메일: job@vdream.co.kr</p>
          </div>
        </div>
      </section>

      <section>
        <h2 className={policyHeadingClass}>12. 정보주체의 권익침해에 대한 구제방법</h2>
        <p className={policyBodyClass}>
          정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보 분쟁조정위원회, 개인정보침해신고센터 등에
          분쟁해결이나 상담 등을 신청할 수 있습니다. 그 밖에 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래
          기관에 문의하시기 바랍니다. 또한 회사는 정보주체의 권리구제를 위하여 내부 고충처리 절차를 운영할 수 있습니다.
        </p>
        <ol className="list-decimal space-y-2 pl-5 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <li>개인정보 분쟁조정위원회: 1833-6972 / www.kopico.go.kr</li>
          <li>개인정보침해신고센터: (국번없이) 118 / privacy.kisa.or.kr</li>
          <li>대검찰청: (국번없이) 1301 / www.spo.go.kr</li>
          <li>경찰청: (국번없이) 182 / ecrm.police.go.kr</li>
        </ol>
      </section>

      <section>
        <h2 className={policyHeadingClass}>13. 개인정보 처리방침의 변경</h2>
        <p className={policyBodyClass}>
          회사는 법령, 서비스 내용 또는 개인정보 처리 현황의 변경이 있는 경우 본 개인정보 처리방침을 개정할 수 있습니다.
          개인정보 처리방침을 변경하는 경우에는 변경사항을 쉽게 확인할 수 있도록 홈페이지 또는 서비스 화면에 지속적으로
          게시하며, 중요한 변경이 있는 경우에는 적용일자 전 합리적인 기간 동안 별도 공지, 팝업, 전자우편 또는 그에
          준하는 방법으로 안내할 수 있습니다.
        </p>
        <div className="mt-4 rounded-xl border border-[#D9E0E7] bg-[#FAFAFA] px-4 py-3 text-[13px] md:text-[15px] leading-7 text-[#374151]">
          <p>공고일자: 2026년 4월 27일</p>
          <p>시행일자: 2026년 6월 1일</p>
        </div>
      </section>
    </div>
  </>,
];

export const TERMS = [
  <>
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">약관안내</p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제1조 목적</p>
    <p className="whitespace-pre-line w-[728px]">
      {`이 약관은 브이드림 ("회사" 또는 "브이드림")가 제공하는 브이드림 사이트 및 관련 제반 서비스의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정하는 것을 목적으로 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제2조 정의</p>
    <p className="whitespace-pre-line w-[728px]">
      {`이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
        ① "서비스"라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 "회원"이 이용할 수 있는 브이드림 사이트 및 관련 제반 서비스를 의미합니다.
        ② "회원"이라 함은 회사의 "서비스"에 접속하여 이 약관에 따라 "회사"와 이용계약을 체결하고 "회사"가 제공하는 "서비스"를 이용하는 고객을 말합니다.
        ③ "게시물"이라 함은 "회원"이 "서비스"를 이용함에 있어 "서비스상"에 게시한 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제3조 약관의 게시와 개정</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 이 약관의 내용을 "회원"이 쉽게 알 수 있도록 사이트 하단에 게시합니다.
        ② "회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호등에관한법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
        ③ "회사"가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 30일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관의 개정의 경우에는 공지 외에 일정기간 서비스 내 전자우편, 전자쪽지 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.
        ④ 회사가 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
        ⑤ 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제4조 약관의 해석</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 "개별 모바일 홈페이지 서비스약관 등")을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "개별 모바일 홈페이지 서비스약관 등"이 우선하여 적용됩니다.
        ② 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 "개별 모바일 홈페이지 등" 및 관계법령 또는 상관례에 따릅니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제5조 이용계약 체결</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① 이용계약은 구직을 하고자 하는 자 또는 구인을 하고자 하는 자(이하 “이용자”)가 약관의 내용에 대하여 동의를 한 다음 브이드림 서비스 신청을 하고 "회사"가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
        ② "회사"는 "이용자"의 신청에 대하여 "서비스" 이용을 승낙함을 원칙으로 합니다. 다만, "회사"는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
        ㅤ1. 이용자가 이 약관에 의하여 이전에 서비스 이용자격을 상실한 적이 있는 경우, 단 "회사"의 재이용 승낙을 얻
        ㅤㅤ 은 경우에는 예외로 함.
        ㅤ2. 실명이 아니거나 타인의 명의를 이용한 경우
        ㅤ3. 허위의 정보를 기재하거나, "회사"가 제시하는 내용을 기재하지 않은 경우
        ㅤ4. 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
        ③ "회사"는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
        ④ 제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, "회사"는 원칙적으로 이를 가입신청자에게 알리도록 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제6조 개인정보보호 의무</p>
    <p className="whitespace-pre-line w-[728px]">
      {`"회사"는 "정보통신망법" 등 관계 법령이 정하는 바에 따라 "회원"의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "회사"의 개인정보취급방침이 적용됩니다. 다만, "회사"의 공식 사이트 이외의 링크된 사이트에서는 "회사"의 개인정보취급방침이 적용되지 않습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제7조 &quot;회원&quot;에 대한 통지</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"가 "이용자"에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소, 전자쪽지 등으로 할 수 있습니다.
        ② "회사"는 "이용자" 전체에 대한 통지의 경우 7일 이상 "회사"의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제8조 &quot;회사&quot;의 의무</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.
        ② "회사"는 "이용자"가 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보취급방침을 공시하고 준수합니다.
        ③ "회사"는 서비스이용과 관련하여 발생하는 이용자의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구비합니다.
        ④ "회사"는 서비스이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. "이용자"가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 "이용자"에게 처리과정 및 결과를 전달합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제9조 &quot;이용자&quot;의 의무</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "이용자"는 다음 행위를 하여서는 안 됩니다.
        ㅤ1. 신청 또는 변경 시 허위내용의 등록
        ㅤ2. 타인의 정보도용
        ㅤ3. "회사"가 게시한 정보의 변경
        ㅤ4. "회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시
        ㅤ5. "회사"와 기타 제3자의 저작권 등 지적재산권에 대한 침해
        ㅤ6. "회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
        ㅤ7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "서비스"에 공개 또는 게시하는 행
        ㅤㅤ 위
        ㅤ8. 회사의 동의 없이 영리를 목적으로 "서비스"를 사용하는 행위
        ㅤ9. 기타 불법적이거나 부당한 행위
        ② "회원"은 관계법, 이 약관의 규정, 이용안내 및 "서비스"와 관련하여 공지한 주의사항, "회사"가 통지하는 사항 등을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제10조 &quot;서비스&quot;의 제공 등</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① 회사는 이용자에게 아래와 같은 서비스를 제공합니다.
        ㅤ1. 게시판형 서비스(1:1문의, 장애인 구직등록, 지원이력서 확인, 고용부담금절감 신청)
        ㅤ2. 기타 "회사"가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 "이용자"에게 제공하는 일체의 서비스
        ② "서비스"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
        ③ "회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 "서비스"의 제공을 일시적으로 중단할 수 있습니다. 이 경우 "회사"는 제7조["이용자"에 대한 통지]에 정한 방법으로 "이용자"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
        ④ "회사"는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제11조 &quot;서비스&quot;의 변경</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 변경할 수 있습니다.
        ② "서비스"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.
        ③ "회사"는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 "이용자"에게 별도의 보상을 하지 않습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제12조 정보의 제공 및 광고의 게재</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 "이용자"가 "서비스" 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 "이용자"에게 제공할 수 있습니다. 다만, "이용자"는 관련법에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편에 대해서 수신 거절을 할 수 있습니다.
        ② 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 "회원"의 사전 동의를 받아서 전송합니다. 다만, "회원"의 거래관련 정보 및 고객문의 등에 대한 회신에 있어서는 제외됩니다.
        ③ "회사"는 "서비스"의 운영과 관련하여 서비스화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다.
        ④ "이용자"는 회사가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지 않습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제13조 &quot;게시물&quot;의 제공 등</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "이용자"가 "서비스" 내에 게시한 "게시물"의 저작권은 해당 게시물의 저작자에게 귀속됩니다.
        ② "이용자"는 언제든지 고객센터 또는 "서비스" 내 문의하기를 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다.
        ③ "회사"는 제2항 이외의 방법으로 "이용자"의 "게시물"을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 "이용자"의 동의를 얻어야 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제14조 &quot;게시물&quot;의 관리</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "이용자"의 "게시물"이 "정보통신망법" 및 "저작권법"등 관련법에 위반되는 내용을 포함하는 경우, "회사"는 관련법에 따라 조치를 취하여야 합니다.
        ② "회사"는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 "게시물"에 대해 임시조치 등을 취할 수 있습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제15조 권리의 귀속</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "서비스"에 대한 저작권 및 지적재산권은 "회사"에 귀속됩니다. 단, "이용자"의 "게시물" 및 제공된 저작물 등은 제외합니다.
        ② "이용자"는 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제16조 이용제한 등</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 "이용자"가 이 약관의 의무를 위반하거나 "서비스"의 정상적인 운영을 방해한 경우, "서비스" 이용을 제한할 수 있습니다.
        ② "회사"는 전항에도 불구하고, "주민등록법"을 위반한 명의도용 및 결제도용, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다.
        ③ "회사"는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 및 개별 서비스상의 운영정책에서 정하는 바에 의합니다.
        ④ "이용자"는 본 조에 따른 이용제한 등에 대해 "회사"가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 "회사"가 인정하는 경우 "회사"는 즉시 "서비스"의 이용을 재개합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제17조 책임제한</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.
        ② "회사"는 "이용자"의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.
        ③ "회사"는 "이용자"이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
        ④ "회사"는 "이용자" 간 또는 "이용자"과 제3자 상호간에 "서비스"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.
        ⑤ "회사"는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">제18조 준거법 및 재판관할</p>
    <p className="whitespace-pre-line w-[728px]">
      {`① "회사"와 "이용자" 간 제기된 소송은 대한민국법을 준거법으로 합니다.
        ② "회사"와 "이용자"간 발생한 분쟁에 관한 소송은 제소 당시의 "이용자"의 주소에 의하고, 주소가 없는 경우 거소를 관할하는 지방법원의 전속관할로 합니다. 단, 제소 당시 "이용자"의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은 민사소송법에 따라 정합니다.
        ③ 해외에 주소나 거소가 있는 "이용자"의 경우 "회사"와 "이용자"간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 부산중앙지방법원을 관할법원으로 합니다.`}
    </p>
    <br />
    <p className="whitespace-pre-line text-[18px] font-[550] mb-2">부칙</p>
    <p className="whitespace-pre-line w-[728px]">{`① 이 약관은 2020년 01월 01일부터 적용됩니다.`}</p>
  </>,
];
